export default __webpack_public_path__ + "static/media/disposeUpdate.1bdb2e6b.jpg";